module.exports = __webpack_public_path__ + "img/购买完.f7e09bd7.svg";